import { Select } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { change_Lang } from "../../actions/Helper_action";
const PropertyesList = ({
  onChangeProperty,
  valueOption,
  defaultValueOption,
  ...rest
}) => {
  const dispatch = useDispatch();
  const { Option } = Select;
  return (
    <Select
      style={{
        borderBottomColor: "#052f43",
      }}
      dropdownStyle={{ textAlign: "center" }}
      className="col-12 fk text-center"
      size="middle"
      showArrow={false}
      onChange={onChangeProperty}
      value={valueOption}
      defaultValue={defaultValueOption}
      showSearch
      optionFilterProp="children"
      filterOption={true}
      {...rest}
    >
      <Option
        className="fk"
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
        value=""
      >
        {dispatch(change_Lang("Choose"))}
      </Option>
      <Option
        className="fk"
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
        value="Apartment"
      >
        {dispatch(change_Lang("Apartment"))}
      </Option>
      <Option
        className="fk"
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
        value="House"
      >
        {dispatch(change_Lang("House"))}
      </Option>
      <Option
        className="fk"
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
        value="Farm"
      >
        {dispatch(change_Lang("Farm"))}
      </Option>
      <Option
        className="fk"
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
        value="Shop"
      >
        {dispatch(change_Lang("Shop"))}
      </Option>
      <Option
        className="fk"
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
        value="Vella"
      >
        {dispatch(change_Lang("Vella"))}
      </Option>
      <Option
        className="fk"
        value="Earth"
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("Earth"))}
      </Option>
      <Option
        className="fk"
        value={"Strecture"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("Strecture"))}
      </Option>
      <Option
        className="fk"
        value={"The gas station"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("The gas station"))}
      </Option>
      <Option
        className="fk"
        value={"Factory"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("Factory"))}
      </Option>
      <Option
        className="fk"
        value={"GYM"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("GYM"))}
      </Option>
      <Option
        className="fk"
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
        value="Car wash"
      >
        {dispatch(change_Lang("Car wash"))}
      </Option>
      <Option
        className="fk"
        value={"store"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("store"))}
      </Option>
      <Option
        className="fk"
        value={"Restaurant"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("Restaurant"))}
      </Option>
      <Option
        className="fk"
        value={"office"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("office"))}
      </Option>
      <Option
        className="fk"
        value={"Building"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("Building"))}
      </Option>
      <Option
        className="fk"
        value={"Agitator"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("Agitator"))}
      </Option>
      <Option
        className="fk"
        value={"residential community"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("residential community"))}
      </Option>
      <Option
        className="fk"
        value={"agricultural land of the register"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("agricultural land of the register"))}
      </Option>
      <Option
        className="fk"
        value={"unregistered agricultural land"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("unregistered agricultural land"))}
      </Option>
      <Option
        className="fk"
        value={"Government agricultural land"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("Government agricultural land"))}
      </Option>
      <Option
        className="fk"
        value={"Land of Istamar"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("Land of Istamar"))}
      </Option>
      <Option
        className="fk"
        value={"Erth Musataha"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("Erth Musataha"))}
      </Option>
      <Option
        className="fk"
        value={"school"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("school"))}
      </Option>
      <Option
        className="fk"
        value={"Building of Istamar"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("Building of Istamar"))}
      </Option>
      <Option
        className="fk"
        value={"Building of Musataha"}
        style={{
          fontWeight: "bold",
          fontSize: "16px",
        }}
      >
        {dispatch(change_Lang("Building of Musataha"))}
      </Option>
    </Select>
  );
};

export default PropertyesList;
